import React from "react";
import PropTypes from "prop-types";

// maps variant key to Tailwind classes
const variantClasses = {
    black: "bg-gray-900 text-gray-100 hover:bg-gray-800 dark:hover:bg-white/85 dark:bg-gray-100 dark:text-gray-800",
    green: "bg-green-600 text-white hover:opacity-90",
    violet: "border-violet-500 bg-violet-600 text-white shadow-lg shadow-violet-950/25 hover:border-violet-400 hover:bg-violet-500",
    "outline-black": "bg-white text-gray-600 border-gray-400 hover:text-black hover:border-black dark:text-white dark:bg-transparent dark:border-gray-500 dark:hover:border-gray-300",
    "outline-primary": "bg-white text-gray-800 border-gray-300 hover:border-gray-400 dark:border-gray-700/60 dark:hover:border-gray-600 dark:text-gray-300 dark:bg-gray-800",
    "outline-red": "bg-white text-red-500 border-red-400 hover:bg-red-50 dark:bg-transparent dark:text-red-500 dark:border-red-500/80 dark:hover:border-red-500 dark:hover:bg-red-900/10 dark:hover:text-red-500",
    "outline-violet": "bg-white text-violet-600 border-violet-600 hover:bg-violet-50 dark:bg-transparent dark:text-violet-300 dark:border-violet-500 dark:hover:border-violet-500 dark:hover:text-violet-100",
    "outline-warning": "bg-white text-orange-700 border-orange-700 hover:text-orange-600 hover:border-orange-600 dark:bg-transparent dark:text-orange-300 dark:border-orange-500 dark:hover:border-orange-400 dark:hover:text-orange-100",
    "outline-cyan": "bg-white text-cyan-600 border-cyan-600 hover:bg-cyan-50",
};

// maps size key to your size classes
const sizeClasses = {
    small: "btn-xs py-1.5",
    normal: "btn",
    large: "btn-lg",
};

const Button = React.forwardRef(function Button(
    {
        children,
        variant = "black",
        size = "normal",
        className = "",
        onClick,
        title,
        disabled = false,
        type = "button",
        ...rest
    },
    ref
) {
    const variants = variantClasses[variant] || "";
    const sizes = sizeClasses[size] || sizeClasses.normal;
    const disabledClass = disabled ? "opacity-50 cursor-not-allowed" : "";

    return (
        <button
            ref={ref}
            type={type}
            className={`${variants} ${sizes} ${disabledClass} ${className}`}
            aria-disabled={disabled}
            disabled={disabled}
            title={title}
            onClick={(e) => {
                e.preventDefault();
                if (!disabled && onClick) {
                    onClick(e);
                }
            }}
            {...rest}
        >
            {children}
        </button>
    );
});

Button.propTypes = {
    children: PropTypes.node.isRequired,
    variant: PropTypes.oneOf(Object.keys(variantClasses)),
    size: PropTypes.oneOf(Object.keys(sizeClasses)),
    className: PropTypes.string,
    onClick: PropTypes.func,
    title: PropTypes.string,
    disabled: PropTypes.bool,
    type: PropTypes.string,
};

export default Button;
